// Создание событий журнала (API.md §3.2). event_id — UUIDv7, ключ идемпотентности.
import { db, type Child, type EventType, type StoredEvent } from "./db.ts";
import { uuidv7 } from "./uuid.ts";

let releaseId: string | undefined;

/** Текущий релиз контента — пишется в события. */
export function setRelease(id: string | undefined) {
  releaseId = id;
}

export async function record(childId: string, type: EventType, payload: Record<string, unknown>): Promise<StoredEvent> {
  const e: StoredEvent = { eventId: uuidv7(), childId, type, occurredAt: new Date().toISOString(), contentRelease: releaseId, payload, state: 0 };
  await db.events.put(e);
  notify();
  return e;
}

export async function upsertChild(c: Child): Promise<void> {
  await db.children.put(c);
  await record(c.id, "child_upserted", { nickname: c.nickname, birth_year: c.birthYear, stage: c.stage, format_code: c.formatCode });
}

const listeners = new Set<() => void>();
/** Подписка на новые события (для пересчёта прогресса и фоновой синхронизации). */
export function onEvents(f: () => void): () => void {
  listeners.add(f);
  return () => listeners.delete(f);
}
export function notify() {
  for (const f of listeners) f();
}
